import React from 'react'

const Second = () => {
    return (
        <div className="second">
            <div className="container">
                <p>Created By Radwa Amer | All Rights Reserved!</p>
            </div>
        </div>
    )
}

export default Second